import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddFundPopupComponent } from './add-fund-popup.component';
import { MatFormFieldModule, MatInputModule, MatButtonModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [AddFundPopupComponent],
  imports: [CommonModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule]
})
export class AddFundPopupModule { }
